/*
 *
 * Package: `@dbh/post-stay-rating-page`.
 *
 */const importPostStayRatingPage=()=>import('./component-219698b6.js'/*  webpackChunkName: 'dbh.post-stay-rating-page.component' */);const importPostStayRatingPageReducersAndSagas=()=>import('./reducers-and-sagas-e4794033.js'/*  webpackChunkName: 'dbh.post-stay-rating-page.reducers-and-sagas' */);// Only export dynamic imports from the `index.js` of our `@dbh/*-page` packages,
// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importPostStayRatingPage, importPostStayRatingPageReducersAndSagas };
